import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../Table/DataTable";
import { filterElements } from "./data";
import API from "../../../Api/Api";
import { getDeliveries } from "../../../REDUX/actions/delivery";
import { useDeparture } from "../useDeparture";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import UpdateDeparture from "../UpdateDeparture";

const DepartureTable = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const [filters, setFilters] = useState({});
  const [selectOptions, setSelectOptions] = useState({
    transporter: [],
    reseller: [],
    preparator: [],
  });
  const { deliveries, loading, pageCount, total } = useSelector(
    (state) => state.deliveryReducer,
  );
  const { headers, columns } = useDeparture();

  const fetchData = (page, search, filters, signal) => {
    dispatch(getDeliveries(page, search, filters, signal));
  };

  useEffect(() => {
    const controller = new AbortController();
    (async function getSelectData() {
      try {
        const { data } = await API.get("/api/delivery-filters", {
          signal: controller.signal,
        });
        setSelectOptions(data?.data);
      } catch (error) {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED")
          return;
        console.log(error);
      }
    })();
    return () => {
      controller.abort();
      dispatch({ type: "RESET_DELIVERIES" });
    };
  }, [dispatch]);

  return (
    <DataTable
      containerClassName="h-100"
      showRowDetails={false}
      newItemTitle={""}
      title={t("Logistics")}
      headers={headers}
      columns={columns}
      fetchData={fetchData}
      filterElements={filterElements(user?.attributes?.userRole).filter(
        (el) => !el.hidden,
      )}
      filters={filters}
      setFilters={setFilters}
      selectOptions={selectOptions}
      totalPages={pageCount}
      data={deliveries}
      loading={loading}
      total={total}
      noResultsMessage="No results found"
      onRowClick={(id) => dispatch(openRightModal(<UpdateDeparture id={id} />))}
      // addNewItem={() => dispatch(openRightModal(<DepotModal />))}
    />
  );
};

export default DepartureTable;
